<template>
    <div class="kline" ref="chart" />
</template>

<script>
import KLineController from '../controller/KLine';
import klineOption from '../controller/echartsOption/kline';
import markPointOption from '../controller/echartsOption/klineMarkPoint';

export default {
    name: 'VueKLineBTE',
    props: {
        configuration: {
            type: Object,
            default: () => {
                return {
                    loadChartOption: klineOption, // 加载的ECharts选项
                    loadMarkPointOption: markPointOption, // 加载的MarkPoint选项
                    requestModule: '', // 请求的服务器端模块。默认:future（kline:只有K线以及相关指标、实时点评数据，future:在K线基础上，还有压力线、净流量、异常大单数据）
                    timeInterval: 60000 // 定时请求数据的时间间隔
                };
            }
        },
        showIndicators: {
            type: Array,
            default: () => {
                return ['MA', 'PRESSURELINE', 'ABNORMALTRANSACTION', 'VOL', 'ABNORMALVOLUME', 'MACD'];
            }
        },
        requestParam: {
            type: Object,
            default: () => {
                return {
                    base: 'BTC', // 币种
                    quote: 'QUARTER', // 币对
                    exchange: 'okex', // 交易所
                    type: '1m', // 时间类型
                    size: '500' // 请求的点数量
                };
            }
        }
    },
    data() {
        return {
            controller: null
        };
    },
    computed: {
        responseData() {
            return this.controller ? this.controller.getResponseData() : null;
        },
        tooltipDataObj() {
            return this.controller ? this.controller.getTooltipDataObj() : null;
        }
    },
    watch: {
        showIndicators(newValue) {
            this.controller.showIndicatorsOnChange(newValue, this.requestParam);
        },
        requestParam: {
            deep: true,
            handler(newValue, oldValue) {
                this.controller.requestParamOnChange(newValue, oldValue);
            }
        },
        responseData(response, oldValue) {
            if (!oldValue) {
                return;
            }

            // 因为有定时器，无法直接返回Promise，所以采用组件监听返回数据的方案
            this.controller.getDataSuccess(this.requestParam, response);
            // 告知外层组件获取数据成功，以便外层组件可以对数据进行操作（比如：是否有实时点评数据，没有则不显示实时点评按钮）
            this.$emit('getDataOnSuccess', response);
        },
        tooltipDataObj(newValue) {
            // 告知外层组件，当前的tooltip数据对象(由availableHeight、gridGroups——每个grid里的series集合、grids——每个grid的option)
            this.$emit('tooltipOnChange', newValue);
        }
    },
    created() {
        this.controller = new KLineController(this.configuration);
        this.controller.showIndicatorsOnChange(this.showIndicators, this.requestParam);
    },
    mounted() {
        this.controller.initChart(this.$refs.chart);
    },
    beforeDestroy() {
        this.controller.clearInterval();
    }
};
</script>

<style lang="scss">
.kline {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/KLine.vue